// react
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";

// project imports
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
// persist
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

// project imports
import store from "./core/store";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

let persistor = persistStore(store);

root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
